const AGENT_LLM_ERROR = { message: "LLM provider error", severity: "error", status: 502, service: "agent" };
const AGENT_TIMEOUT = { message: "Agent request timed out", severity: "error", status: 504, service: "agent" };
/** Agent service codes. Canonical `AGT-*`; legacy flat names kept as aliases. */
export const AGENT_ERRORS = {
    "AGT-LLM-ERROR": AGENT_LLM_ERROR,
    "AGT-TIMEOUT": AGENT_TIMEOUT,
    AGENT_LLM_ERROR,
    AGENT_TIMEOUT,
};
//# sourceMappingURL=agent.js.map